import { render, staticRenderFns } from "./RoundModalDetail.vue?vue&type=template&id=c77782e8&"
import script from "./RoundModalDetail.vue?vue&type=script&lang=ts&"
export * from "./RoundModalDetail.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports